import { NgModule } from '@angular/core';

import { AutoFocusDirective } from './autofocus.directive';

@NgModule({
  declarations: [AutoFocusDirective],
  exports: [AutoFocusDirective]
})
export class AutoFocusModule { }
